<template>
    <!-- 数字通证管理 -->
    <div>
        <!-- 新增按钮 -->
        <div class="onBtn">
            <el-button type="success" style="margin-left: auto" @click="addAgreement">新增</el-button>
        </div>
        <!-- 内容区域 -->
        <div>
            <el-table :data="form" border style="width: 100%">
                <el-table-column prop="id" label="协议ID" align="center">
                </el-table-column>
                <el-table-column prop="name" label="协议标题" align="center">
                </el-table-column>
                <!-- <el-table-column prop="content" label="协议内容" align="center">
                </el-table-column> -->
                <el-table-column prop="createTime" label="新增时间" align="center">
                </el-table-column>
                <el-table-column label="状态" align="center">
                    <template v-slot="scope">
                        <div>
                            {{ scope.row.status == 1 ? '启用' : '禁用' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="操作" align="center">
                    <template v-slot="{ row }">
                        <el-button @click="editInfo(row, '1')" type="text">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                :page-sizes="[10, 15, 20, 30]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="新增协议" :visible.sync="dialog" width="1000px" center>
            <AddAgreement @close="closeDialog"></AddAgreement>
        </el-dialog>
        <el-dialog title="协议详情" :visible.sync="detDialog" width="1000px" center>
            <el-form :model="param" label-width="120px">
                <el-form-item label="协议标题" prop="content">
                    {{ param.name }}
                </el-form-item>
                <el-form-item label="新增时间" prop="content">
                    {{ param.createTime }}
                </el-form-item>
                <el-form-item label="是否启用" prop="content">
                    {{ param.status == 1 ? '启用' : '禁用' }}
                </el-form-item>
                <el-form-item label="协议内容">
                    <div class="contant-list" v-html="param.content"></div>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
  
<script>
import AddAgreement from './addAgreement.vue'
export default {
    components: {
        AddAgreement
    },
    data() {
        return {
            form: [],
            total: 0,
            pageSize: 10,
            currentPage: 1,
            dialog: false,
            param: {
                name: '',
                content: '',
                createTime: '',
                id: null,
                status: 1
            },
            detDialog: false
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        closeDialog() {
            this.dialog = false
            this.getList()
        },
        getList() {
            this.axios
                .get("/admin/jttAgreement/findAll", {
                    pageNumber: this.currentPage,
                    pageSize: this.pageSize,
                })
                .then((res) => {
                    this.form = res.data.data.records;
                    this.total = res.data.data.total;
                });
        },
        editInfo(row) {
            this.param = row
            this.detDialog = true
        },
        addAgreement() {
            // this.$router.push('addAgreement')
            this.dialog = true
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList();
        },
    },
};
</script>
  
<style lang="scss" scoped>
.onBtn {
    display: flex;
    align-items: center;
    padding: 20px;
}

.btn {
    display: flex;
    justify-content: center;

    div {
        margin: 0 3px;
        font-size: 12px;
        color: #409eff;
    }

    div:hover {
        cursor: pointer;
    }
}

.pagination {
    display: flex;
    justify-content: center;
    margin-top: 50px;
}
</style>
<style>
.contant-list img {
    max-width: 100%;
    height: auto;
}
</style>